import styled from '@emotion/styled'
import compact from 'lodash/compact'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { AccessLevel, useAccessLevel } from '@/hooks/useAccessLevel'
import { APP_TYPE } from '@/types/User'
import { APP_STORAGE_KEY } from '@/util'

type Props = {
  activeApp: APP_TYPE
  minimize: boolean
  smallScreen: boolean
}

export const AppSelection = ({ activeApp, minimize, smallScreen }: Props) => {
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const { accessGranted } = useAccessLevel()
  const { HUB_MANAGER } = AccessLevel

  const appMenuOptions = compact([
    { label: 'Support', value: APP_TYPE.SUPPORT },
    { label: 'Sales', value: APP_TYPE.SALES },
    accessGranted([HUB_MANAGER]) ? { label: 'Communications', value: APP_TYPE.COMMUNICATIONS } : null,
    accessGranted([HUB_MANAGER]) ? { label: 'Settings', value: APP_TYPE.SETTINGS } : null,
  ])

  const switchApp = (value) => {
    localStorage.setItem(APP_STORAGE_KEY, value)
    window.location.assign('/')
  }

  const selectedMenuOption = appMenuOptions.find((option) => option.value === activeApp)

  return (
    <>
      {!minimize ? (
        <Dropdown
          className="cursor-pointer flex-row mr-2 ml-2 mb-2 lg:flex"
          dropdownButtonStyle={styles.dropdownButton}
          expanded={dropdownExpanded}
          headerTitle={selectedMenuOption?.label || 'Mission Control'}
          onHideDropdown={() => setDropdownExpanded(false)}
          renderHeader={() => <div></div>}
          selected={!!activeApp}
          setExpanded={setDropdownExpanded}
        >
          <FilterOptionsStyled smallScreen={smallScreen}>
            <ul>
              {appMenuOptions.map((val, i) => (
                <li
                  className={`${activeApp === val.value ? 'selected' : ''}`}
                  key={i}
                  onClick={() => switchApp(val.value)}
                  role={'presentation'}
                >
                  {val.label}
                </li>
              ))}
            </ul>
          </FilterOptionsStyled>
        </Dropdown>
      ) : null}
    </>
  )
}

const FilterOptionsStyled = styled.div<{ smallScreen: boolean }>`
  ${({ smallScreen }) => (smallScreen ? 'width: 100%;' : 'width: 13rem;')}

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;

    li {
      &.selected {
        background-color: #e7e6e4;

        &:hover {
          background-color: #e7e6e4;
        }
      }
      margin-bottom: 0.25rem;
      width: 100%;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      cursor: pointer;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      line-height: 1;
      &:hover {
        background-color: #f3f3f2;
      }
    }
  }
`

const styles = {
  dropdownButton: {
    backgroundColor: '#0D7A6D',
    border: 'none',
    width: '90%',
  },
}
